"use client"

import { toImageSrc } from "@/lib/utils"
import Image from "next/image"
import Link from "next/link"

interface FieldActivityItemProps {
  field: {
    backgroundImage?: string
    icon?: string
    title?: string
    website?: string
    link?: string
  }
  index: number
  className?: string
}

export const FieldActivityItem: React.FC<FieldActivityItemProps> = ({ field, index, className = "" }) => {
  const backgroundUrl = field.backgroundImage ? toImageSrc(field.backgroundImage) : null
  const iconUrl = field.icon ? toImageSrc(field.icon) : null

  return (
    <Link
      key={index}
      href={field.link || "#"}
      className={`relative group overflow-hidden rounded-lg sm:min-h-[346px] h-[216px] cursor-pointer ${className}`}
    >
      {backgroundUrl && (
        <div
          className="absolute inset-0 field-activity-background"
          style={{
            background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)) 0% 0% / cover no-repeat, url(${backgroundUrl})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      )}
      <div className="absolute top-0 left-0 right-0 bottom-0 rounded-lg opacity-0 group-hover:opacity-90 transition-all duration-300 ease-in field-activity-overlay"></div>

      <div className="relative h-full flex flex-col sm:gap-2 gap-4 items-center justify-center p-6 text-center z-10 scale-100 group-hover:animate-[zoom_0.3s_ease-in_forwards]">
        {iconUrl && (
          <div className="w-14 h-14 relative">
            <Image src={iconUrl} alt={field.title || field.website || "Field"} fill className="object-contain" />
          </div>
        )}

        {field.title && (
          <h3
            className="text-white sm:text-2xl sm:leading-[26px] text-base leading-[22.4px] font-bold uppercase"
            dangerouslySetInnerHTML={{
              __html: field.title.replace(/\n/g, "<br/>"),
            }}
          />
        )}

        {field.website && <p className="text-white sm:text-lg text-base leading-[22.4px] font-bold">{field.website}</p>}
      </div>
    </Link>
  )
}
